import { LenderName } from '@nemuru-eng/js-api-client';
import React from 'react';

interface LenderLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  lenderName: LenderName;
  size?: number;
}

export const LenderLogo = ({ lenderName, size = 24, ...props }: LenderLogoProps) => {
  return (
    <img
      src={`https://cdn.nemuru.com/assets/logos/${lenderName}-logo.svg`}
      alt={lenderName}
      {...props}
      style={{ ...props.style, height: size, width: 'auto' }}
    />
  );
};
